import { styled } from '@lichtblick/styled';
import { Colors, Spacing } from '@lichtblick/theme';

export const SidesheetContainer = styled.div`
  background-color: ${Colors.blue[3]};
  box-sizing: border-box;
  height: 100%;
  max-width: 20rem;
  overflow-wrap: break-word;
  overflow-x: auto;
  padding: ${Spacing.M};
  width: 100%;
  word-break: break-word;
`;
